import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const resendAdminOrderEmailReducer = createReducer<State, Actions>(initialState, {
  [actions.resendAdminOrderEmail.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.resendAdminOrderEmail.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.resendAdminOrderEmail.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.resendAdminOrderEmail.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default resendAdminOrderEmailReducer;
